export class UnarchiveUsersRequestDTO {
  constructor(public userIds: string[]) {}
}
